import {all} from 'redux-saga/effects';
import authSagas from './Auth';
import countrySaga from './Country';
import lookupSagas from './Lookup';
import userSaga from './User';

export default function* rootSaga(getState){
  yield all([ authSagas(), countrySaga(), lookupSagas(), userSaga() ]);
}
